// FOC-492 — Service para los endpoints de verificación de dispositivo.
//
//   verifyDevice(code) → POST /api/user/device/verify con el código.
//                        Si OK, devuelve el payload del login (user, token,
//                        allowed, menu...) y limpia el estado de verificación.
//                        Si falla (401, 400, 403), re-lanza para que el
//                        componente lo maneje: NO va al auto-refresh de
//                        sesión (skipAuthRefresh=true).
//
//   resendCode()        → POST /api/user/device/resend sin body. Si OK,
//                        resetea el countdown del reenvío.
//
// Las dos llamadas reutilizan la instancia `API()` existente (que ya tiene
// installDpop configurado) porque el getToken cae al verification token
// cuando no hay sesión (ver src/api/API.js).

import { API } from '../../../api/API'
import { clearVerification, markResent } from './deviceVerification'

const VERIFY_PATH = 'user/device/verify'
const RESEND_PATH = 'user/device/resend'

// Marcador que lee el response interceptor de installDpop para NO disparar
// la redirección a login en los 401 de estos endpoints: un 401 acá significa
// "venció el token temporal de 15 min" y lo maneja la pantalla, no la
// recarga global.
const NO_REFRESH = { skipAuthRefresh: true }

export const verifyDevice = async (code) => {
  try {
    const response = await API().post(VERIFY_PATH, { code }, NO_REFRESH)
    clearVerification()

    return response.data.data
  } catch (error) {
    const status = error.response?.status
    const bodyCode = error.response?.data?.code
    if (status === 401 || bodyCode === 'ACCOUNT_BLOCKED') {
      clearVerification()
    }
    throw error
  }
}

export const resendCode = async () => {
  try {
    await API().post(RESEND_PATH, {}, NO_REFRESH)
    markResent()
  } catch (error) {
    if (error.response?.status === 401) {
      clearVerification()
    }
    throw error
  }
}
